import { render, staticRenderFns } from "./PricingSheetModuleNameCell.vue?vue&type=template&id=12ef1748&scoped=true"
import script from "./PricingSheetModuleNameCell.vue?vue&type=script&lang=js"
export * from "./PricingSheetModuleNameCell.vue?vue&type=script&lang=js"
import style0 from "./PricingSheetModuleNameCell.vue?vue&type=style&index=0&id=12ef1748&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ef1748",
  null
  
)

export default component.exports